import React from 'react';
import ReportForm from '../../Forms/Formular/ReportForm';

const ReportPage: React.FC = () => {
  return (
    <div className="container">
      <div className="page-content-text">
        <p>
          Hier kann die Auswertung des Angebotsformulares
          heruntergeladen werden.
        </p>
      </div>
      <ReportForm />
    </div>
  );
};

export default ReportPage;
